module.exports = __webpack_public_path__ + "static/media/app-store-button.a9f4facc.svg";